import { SettingsFormValues } from 'src/Elements/SystemSettings/Battery/types'
import { BatterySettingsDto } from 'src/Libs/batteries/api/dto/battery-overview.dto'
import { VALUE_MEANS_DISABLED } from 'src/Libs/batteries/constants'

/**
 * Creates an update dto for a battery setting.
 *
 * Resets the adjustment value to `0` if it is disabled. See wiki for [more information](https://docs.e3dc.com/display/CLOUD/1.1.5.2.2+-+Battery)
 * about the state control.
 *
 * @param formValues
 */
const settingsFormToDtoTransformer = (formValues: SettingsFormValues): BatterySettingsDto => {
  const adjustmentValue = formValues.isAdjustmentEnabled ? Number(formValues.voltage) : VALUE_MEANS_DISABLED

  return {
    batVoltageAdjust: adjustmentValue,
  }
}

export default settingsFormToDtoTransformer
